webpackJsonp([3],{

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./imgs/biz_content_03_bg.png?d80ae75907af52625a259209cdd53c94";

/***/ }),

/***/ 106:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-margin-bottom"
  }, [_c('div', {
    staticClass: "tx-page-title"
  }, [_vm._v("戈壁徒步")]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid content-style"
  }, [_c('video', {
    attrs: {
      "width": "100%",
      "controls": "controls",
      "preload": "none",
      "poster": "imgs/culture/gbwh_img1.jpg"
    }
  }, [_c('source', {
    attrs: {
      "src": "imgs/culture/gbwh_mp42.mp4",
      "type": "video/mp4"
    }
  }), _vm._v("\n            很抱歉，您的浏览器不支持观看此视频。\n        ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("【玄奘之路】")]), _vm._v(" "), _c('p', [_vm._v("大唐贞观年间，玄奘法师由古丝绸之路经中亚往印度取经、讲学，历时19年，行程5万余里，途经110多个国家。他带回了大昼佛教经典，写就了《大唐西域记》，主持译经1335 卷，远绍如来，近光遗法。")]), _vm._v(" "), _c('p', [_vm._v("1300年前，玄奘法师在这里经历追杀、背弃、迷路、彷徨、生死......最终立下铮铮誓言∶ \"宁可就西而死，岂能归东而生\"， 五天四夜滴水未进几将殒绝，但依然心无所惧一往无前， 最终实现了从坚持到超越的伟大升华。")]), _vm._v(" "), _c('p', [_vm._v("玄奘西行之路1万多公里，行走在这里，沿途会经过草地、丘陵、 河道、沙漠、梭林。在这里，与你同行的不止眼前的同伴，还有远古的生命和早期的圣贤。")]), _vm._v(" "), _c('p', [_vm._v("行走在历史的时空里，去对话这片土地上风沙烈日曾经触及过的生命。")]), _vm._v(" "), _c('h3', [_vm._v("【戈壁精神】")]), _vm._v(" "), _c('p', [_vm._v("玄奘法师迎难而上及坚持不懈的取经精神与同熙精神“做对的事，做难的事，做需要时间沉淀的事”高度契合，每位同熙人都应具备永不言弃的戈壁精神。因此，自2022年起同熙商业正式开展【戈壁远征110公里四天三晚徒步挑战】，将于每年挑选优秀的员工代表参与，一同完成戈壁徒步的极限考验及自我超越。")]), _vm._v(" "), _c('h3', [_vm._v("【熙一 · 2022】")]), _vm._v(" "), _c('p', [_vm._v("出行时间：2022年9月6日—11日")]), _vm._v(" "), _c('p', [_vm._v("出行人数：10人")]), _vm._v(" "), _c('p', [_vm._v("徒步主题：风里劲闯，不息自强")]), _vm._v(" "), _c('video', {
    attrs: {
      "width": "100%",
      "controls": "controls",
      "preload": "none",
      "poster": "imgs/culture/gbwh_mp4bg.jpg"
    }
  }, [_c('source', {
    attrs: {
      "src": "imgs/culture/gbwh_mp4.mp4",
      "type": "video/mp4"
    }
  }), _vm._v("\n            很抱歉，您的浏览器不支持观看此视频。\n        ")]), _vm._v(" "), _c('p', [_vm._v("如果一个团队，具备了清晰的目标、吃苦的准备、坚忍的意志、互助的品格、奋进的精神，定能披荆斩棘、勇立潮头。未来，所有同熙人将带着这股戈壁精神勇往直前，克服万难，抵达胜利的终点！")]), _vm._v(" "), _c('a', {
    staticClass: "text_a",
    attrs: {
      "href": "https://mp.weixin.qq.com/s/Ws7en9GNBKRI0eMBe05BEg",
      "target": "_blank"
    }
  }, [_vm._v("了解更多")]), _vm._v(" "), _c('h3', [_vm._v("【熙二 · 2023】")]), _vm._v(" "), _c('p', [_vm._v("出行时间：2023年9月9日—14日")]), _vm._v(" "), _c('p', [_vm._v("出行人数：10人")]), _vm._v(" "), _c('p', [_vm._v("徒步主题：无畏无惧，奋勇向前")]), _vm._v(" "), _c('video', {
    attrs: {
      "width": "100%",
      "controls": "controls",
      "preload": "none",
      "poster": "imgs/culture/gbwh_mp4bg2.jpg"
    }
  }, [_c('source', {
    attrs: {
      "src": "imgs/culture/gbwh_mp4_2.mp4",
      "type": "video/mp4"
    }
  }), _vm._v("\n            很抱歉，您的浏览器不支持观看此视频。\n        ")]), _vm._v(" "), _c('p', [_vm._v("“逆境和挑战只要能激发起生命的力度，我们的成就是可以超乎自己所想象的”。戈壁是一条由勇气、信念、坚持浇铸而成的文化传承之路，也是锻炼同熙人坚强意志之路。熙军用乐观向上的心态，永不言弃的毅力，团结协助的品质去面对和战胜一切困难。无畏无惧，奋勇向前！")]), _vm._v(" "), _c('a', {
    staticClass: "text_a",
    attrs: {
      "href": "https://mp.weixin.qq.com/s/LV5MB3MYNpOYrOjvs4Y7sg",
      "target": "_blank"
    }
  }, [_vm._v("了解更多")])])])
}]}

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(70);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(7)("71bcab01", content, true);

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

var Vue = __webpack_require__(3);
var VueI18n = __webpack_require__(0);
Vue.use(VueI18n);

//import nls
var nls = __webpack_require__(4);
var defaultLocale = localStorage.getItem("defaultLocale");
if (defaultLocale == null) {
    defaultLocale = nls.defaultLocale;
}
var i18n = new VueI18n({
    locale: defaultLocale, // set locale
    messages : nls.text, // set locale messages
});

// 获取组件引用
// var testC = require('./components/App.vue');
var header_comp = __webpack_require__(2);
var body_comp = __webpack_require__(21);
var footer_comp = __webpack_require__(1);

window.vm = new Vue({
    i18n : i18n,  // VueI18n 插件
    el:"#app",
    components: {
        header_comp: header_comp,
        body_comp: body_comp,
        footer_comp: footer_comp
    }
});

// $(document).ready(function () {
//     $('#modal_video').on('hide.bs.modal', function () {
//         document.getElementById('video').pause();
//     });
// });


/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(130)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(106),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 43:
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


module.exports = {
    computed: {
        pan_height_line1: function () {
            return {
                pan_height_line1_zh: this.$i18n.locale != 'en_US',
                pan_height_line1_en: this.$i18n.locale == 'en_US'
            };
        },
        pan_height_line2: function () {
            return {
                pan_height_line2_zh: this.$i18n.locale != 'en_US',
                pan_height_line2_en: this.$i18n.locale == 'en_US'
            };
        }
    },
    mounted: function () {

        $('#fundCert').viewer({
            scalable: false,
            navbar: false,
            title: false,
            toolbar: false,
            url: 'data-original'
        });
        window.pageTitle = {
            en_US: this.$i18n.messages.en_US.page_title_culture,
            zh_HK: this.$i18n.messages.zh_HK.page_title_culture,
            zh_CN: this.$i18n.messages.zh_CN.page_title_culture
        };
        window.setTitle(window.pageTitle[this.$i18n.locale]);
    }

};

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "body,html{position:relative;height:100%;font-size:12px}.swiper-container{width:100%;height:100%}body:after{background-image:url(" + __webpack_require__(89) + ");background-repeat:no-repeat;background-size:cover}.pan_height_line1_zh{height:auto}@media (min-width:992px){.pan_height_line1_zh{height:360px}}@media (min-width:1200px){.pan_height_line1_zh{height:340px}}.pan_height_line1_en{height:auto}@media (min-width:992px){.pan_height_line1_en{height:360px}}@media (min-width:1200px){.pan_height_line1_en{height:340px}}.pan_height_line2_zh{height:auto}@media (min-width:992px){.pan_height_line2_zh{height:220px}}@media (min-width:1200px){.pan_height_line2_zh{height:220px}}.pan_height_line2_en{height:auto}@media (min-width:992px){.pan_height_line2_en{height:220px}}@media (min-width:1200px){.pan_height_line2_en{height:220px}}.container-margin-bottom{margin-bottom:10px}@media (min-width:768px){.container-margin-bottom{margin-bottom:60px}}.pan-num{text-align:center;font-size:80px;color:#d3a571;padding-left:20px;padding-top:25px}@media (min-width:768px){.pan-num{font-size:144px;padding-top:0}}.pan-num-size{width:80px}@media (min-width:768px){.pan-num-size{width:130px}}@media (min-width:992px){.pan-num-size{width:130px}}@media (min-width:1200px){.pan-num-size{width:150px}}.pan-01-wrapper{padding:0 0 30px}@media (min-width:768px){.pan-01-wrapper{padding:0 0 30px}}@media (min-width:992px){.pan-01-wrapper{padding:0 45px 30px 0}}@media (min-width:1200px){.pan-01-wrapper{padding:0 45px 30px 0}}.pan-01{background:#fff;background-image:url(" + __webpack_require__(8) + ");background-position-x:right;background-position-y:top;background-repeat:no-repeat;background-size:20% auto;box-shadow:0 2px 4px 0 rgba(0,0,0,.5)}@media (min-width:768px){.pan-01{background-size:15% auto}}@media (min-width:992px){.pan-01{background-size:30% auto}}.pan-01b-size{width:70%}@media (min-width:768px){.pan-01b-size{width:80%}}@media (min-width:992px){.pan-01b-size{width:70%}}.pan-01-detail-size{width:85%}@media (min-width:768px){.pan-01-detail-size{width:85%}}@media (min-width:992px){.pan-01-detail-size{width:70%}}.pan-02-wrapper{padding:0 0 30px}.pan-02{background:#fff;background-image:url(" + __webpack_require__(9) + ");background-position-x:right;background-position-y:bottom;background-repeat:no-repeat;background-size:20% auto;box-shadow:0 2px 4px 0 rgba(0,0,0,.5)}@media (min-width:768px){.pan-02{background-size:20% auto}}@media (min-width:992px){.pan-02{background-size:28%}}@media (min-width:1200px){.pan-02{background-size:auto}}.pan-02b-size{width:70%}@media (min-width:768px){.pan-02b-size{width:80%}}@media (min-width:992px){.pan-02b-size{width:65%}}@media (min-width:1200px){.pan-02b-size{width:60%}}.pan-02-detail-size{width:85%}@media (min-width:768px){.pan-02-detail-size{width:80%}}@media (min-width:992px){.pan-02-detail-size{width:68%}}@media (min-width:1200px){.pan-02-detail-size{width:65%}}.pan-03-wrapper{padding:0 0 30px}@media (min-width:768px){.pan-03-wrapper{padding:0 0 30px}}@media (min-width:992px){.pan-03-wrapper{padding:0 0 30px}}@media (min-width:1200px){.pan-03-wrapper{padding:0 0 30px}}.pan-03{background:#fff;background-image:url(" + __webpack_require__(10) + ");background-position-x:right;background-position-y:bottom;background-repeat:no-repeat;background-size:25% auto;box-shadow:0 2px 4px 0 rgba(0,0,0,.5)}@media (min-width:768px){.pan-03{background-size:28% auto}}@media (min-width:992px){.pan-03{background-size:31% auto}}@media (min-width:1200px){.pan-03{background-size:33% auto}}.pan-03b-size{width:70%}@media (min-width:768px){.pan-03b-size{width:75%}}@media (min-width:992px){.pan-03b-size{width:75%}}@media (min-width:1200px){.pan-03b-size{width:80%}}.pan-03-detail-size{width:80%}@media (min-width:768px){.pan-03-detail-size{width:70%}}@media (min-width:992px){.pan-03-detail-size{width:70%}}@media (min-width:1200px){.pan-03-detail-size{width:65%}}.pan-04-wrapper{padding:0 0 30px}.pan-04{background:RGBA(0,0,0,.5);box-shadow:0 2px 4px 0 rgba(0,0,0,.5)}.content-style{background-color:#fff;margin:0;padding:20px}@media (min-width:768px){.content-style{background-color:#fff;margin:0 20px 80px;padding:20px 25px}}.item-padding{height:893px;padding:0}@media (min-width:768px){.item-padding{padding:0 25px}}.content-style img{display:block;width:100%;margin-bottom:20px}.content-style h3{display:block;margin-top:30px;margin-bottom:10px;color:#d3a571;text-indent:-10px}.content-style P{font-size:16px;text-align:justify}.content-style video{margin:20px 0}.content-style .text_a{display:inline-block;padding:4px 10px;margin-top:10px;background-color:#ffc000;color:#222;font-size:16px;line-height:normal}@media (max-width:992px){.tx-page-title{margin-left:0;margin-right:0}}", ""]);

// exports


/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./imgs/biz_content_01_bg.png?3ef0485f5999dcbf2922507024d4622e";

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./imgs/gbwh_bg.jpg?43de612402677b3b7cd494d6c72e23ee";

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./imgs/biz_content_02_bg.png?b7c3375f8da4b407281b6eca62a5efd4";

/***/ })

},[154]);


// WEBPACK FOOTER //
// js/culture.bundle.js?f8ed5d3265ef9bf48ec5